<template>
  <div class="list errCheck">
    <div class="auctionRegister">
      <h1 class="topTitle">定型文管理</h1>
      <!-- <button @click="test">test</button> -->
      <div class="container">
        
        <div class="">
        
          <div>
            <label>
              商品情報取得テンプレート
              <span>※商品情報を入力する箇所に{item}と入力してください</span>
              <textarea rows="10" v-model="item.ITEM_INFO"></textarea>
            </label>
          </div>
          <div>
            <label>
              いいねがついた時のコメント
              <textarea rows="5" v-model="item.IINE"></textarea>
            </label>
          </div>
          <!-- <div>
            
          <label>
            コメントがついた時のコメント
            <textarea rows="5" v-model="item.COMMENT"></textarea>
          </label>
          </div> -->
          <div>
            <label>
              売れた時のコメント
              <textarea rows="5" v-model="item.SELLED"></textarea>
           </label>
          </div>
           <button class="btn repage" @click="update">登録する</button>
        </div>
      <div class="btnBox subArea">
        <button class="btn repage" @click="returnPage">戻る</button>
        <!-- <button class="btn submit" @click="register" :disabled="isDisabled" >登録する</button> -->
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import { fixedPhraseRepository  } from "@/Repositories/fixedPhraseRepository.js";

import VueJsPaginate from "vuejs-paginate";
import Datepicker from "vuejs-datepicker";
import { ja } from "vuejs-datepicker/dist/locale";
import moment from "moment";
export default {
  data() {
    return {
      /******************
       * ユーザー情報
       ******************/
      userInfo: {},
      userList: [],
      setUserId: "",
      tmpSiteType: null,
      /******************
       * 登録情報
       ******************/
      item:{},
    };
  },
  methods: {
    returnPage() {
      let vm = this;
      vm.$router.back();
    },

    update(){
      fixedPhraseRepository.methods.update(this.item).then(res=>{
          this.$swal({
              title: "登録が完了しました",
              icon: "success",
          })
      })
    }
  },
  computed: {
    
  },
  created: async function () {
    let vm = this;
    // await vm.init();

    fixedPhraseRepository.methods
      .getAll()
      .then((res) => {
        var data = res.data;
        if(data) vm.item = data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="scss">
@import "../style/errCheck.scss";
@import "../style/auctionRegister.scss";
label{
  font-weight: bold;
}
</style>